<div
	class="message"
	[attr.data-utag-error-response]="errorCode ? errorCode : null"
	[style.width.px]="width"
	[class.mobile]="isMobile"
>
	<div class="message-container">
		<div class="content">
			<img *ngIf="image" [src]="image" />
			<div *ngIf="title" class="title" [innerHTML]="title"></div>
			<p *ngIf="msg" class="msg" [innerHTML]="msg"></p>
			<ng-content></ng-content>
			<p
				*ngIf="finePrints"
				class="fine-prints"
				[innerHTML]="finePrints"
			></p>
		</div>
		<div class="actions">
			<div class="action" *ngFor="let action of actions">
				<button
					mat-raised-button
					dodo-raised-button
					[height]="50"
					color="primary"
					(click)="_buttonClicked(action.id)"
					[disabled]="disabled || _busy"
				>
					{{ action.name }}
				</button>
			</div>
		</div>
	</div>
</div>
